import React from 'react';
export const Footer = () => {
  return <div className="w-full bg-black text-white text-sm py-8 px-4 md:px-8" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <div className="mb-6" data-id="element-46">
          <h3 className="font-bold mb-2" data-id="element-47">Contact Us</h3>
          <ul className="list-disc pl-5" data-id="element-48">
            <li data-id="element-49">FRZN Jewelry</li>
            <li data-id="element-50">Houston, Texas, USA</li>
            <li data-id="element-51">Email: support@frznjewelry.co</li>
            <li data-id="element-52">
              Customer service hours: Monday to Saturday: 09:00 am to 5:00 pm
            </li>
            <li data-id="element-53">Shop hours: Monday to Friday: 10:00 am to 3:00 pm</li>
          </ul>
        </div>
        <div className="text-xs opacity-75" data-id="element-54">
          <h3 className="font-bold mb-2" data-id="element-55">
            Privacy Policy & Marketing Disclosure
          </h3>
          <p className="mb-2" data-id="element-56">
            We value your privacy and are committed to transparency. While we
            may collect personal information for marketing purposes, we will
            always inform you of the reasons behind such collection. Please note
            that this website uses cookies to enhance your browsing experience
            and to serve targeted advertisements.
          </p>
          <p className="mb-2" data-id="element-57">
            This website contains a sponsored advertorial. We receive
            compensation for the sale of FRZN Jewelry and other advertised
            products. In addition, the website may earn a financial commission
            to the products we recommend when a qualified lead is referred.
          </p>
          <p data-id="element-58">
            Disclaimer: This is an advertisement and not an actual news article,
            blog, or consumer protection update.
          </p>
        </div>
        <div className="mt-6 text-center" data-id="element-59">
          <a href="#" className="inline-block bg-white text-black font-bold px-8 py-3 rounded-full text-sm hover:bg-gray-200 transition-colors" data-id="element-60">
            VISIT OUR STORE
          </a>
        </div>
      </div>
    </div>;
};